const getResetEmail = state => state.auth.resetEmail;

export default getResetEmail;
